import React, {useEffect, useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import Spinner from "reactjs-simple-spinner";
import {Link} from "react-router-dom";
import {Card, CardActionArea, CardActions, CardContent} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import {makeStyles} from "@material-ui/core/styles";
import AgentService from "../../../services/AgentService";
import SettingsService from "../../../services/SettingsService";


function getModalStyle() {
    const top = 40;
    const left = 40;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    root1: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        width: "45%",
        backgroundColor: theme.palette.background.paper,
        border: '0.2px solid #000',
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2, 4, 3),
    },
}));

const Teams = (props) => {

    const [teams, setTeams] = useState([])
    const [team, setTeam] = useState('')
    const [updateTeam, setUpdateTeam] = useState({id: '', name: ''})
    const [loading, setLoading] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [addLoading, setAddLoading] = useState(false);
    const [modalStyle] = React.useState(getModalStyle);
    const [open, setOpen] = React.useState(false);
    const [updateOpen, setUpdateOpen] = React.useState(false);
    const classes = useStyles();

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    }

    const handleUpdateOpen = (data) => {
        setUpdateTeam({
            id: data.id,
            name: data.teamTitle
        })
        setUpdateOpen(true);
    };

    const handleUpdateClose = () => {
        setUpdateOpen(false);
    }

    const handleAddTeam = () => {
        setAddLoading(true);
        console.log(team);
        SettingsService.addTeam({
            teamTitle: team
        }).then(res => {
            console.log("res: ", res)
            if (res.status === 200 || res.status === 201) {
                SettingsService.getTeams().then(response => {
                    console.log(response);
                    if (response === undefined) {
                        setTeams([])
                        toast.warning('✅ Team Added, 🚫 Failed to get teams ', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setTeam('')
                        handleClose()
                        setAddLoading(false);
                    }
                    let teams = response.data.teams;
                    setTeams(teams);
                    toast('✅ Team Added ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setTeam('')
                    handleClose()
                    setAddLoading(false);

                    //   console.log();                                                                                        );
                }).catch(err => {
                    console.log(err);
                    setTeams([])
                    setTeam('')
                    handleClose()
                    toast.warning('✅ Team Added , 🚫 Failed to get teams ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setAddLoading(false);
                });

            } else {
                toast.warning('🚫 Failed to add team ' + res.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setAddLoading(false);
            }
        })
            .catch((err) => {
                console.log("error: ", err)
                toast.warning('🚫 Failed to add team ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setAddLoading(false);
            })
    }

    const handleUpdate = () => {
        setUpdateLoading(true);
        console.log(updateTeam);
        SettingsService.updateTeam({
            id: updateTeam.id,
            teamTitle: updateTeam.name
        }).then(res => {
            console.log("res: ", res)
            if (res.status === 200 || res.status === 201) {
                SettingsService.getTeams().then(response => {
                    console.log(response);
                    if (response === undefined) {
                        setTeams([])
                        toast.warning('✅ Team Updated, 🚫 Failed to get teams ', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        handleUpdateClose()
                        setUpdateLoading(false);
                    }
                    let teams = response.data.teams;
                    setTeams(teams);
                    toast('✅ Team Updated ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    handleUpdateClose()
                    setUpdateLoading(false);

                    //   console.log();                                                                                        );
                }).catch(err => {
                    console.log(err);
                    setTeams([])
                    handleUpdateClose()
                    toast.warning('✅ Team Updated , 🚫 Failed to get teams ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);
                });

            } else {
                toast.warning('🚫 Failed to update team ' + res.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            }
        })
            .catch((err) => {
                console.log("error: ", err)
                toast.warning('🚫 Failed to update team ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            })
    }

    useEffect(() => {
        setLoading(true);
        setUpdateLoading(false);
        setAddLoading(false);
        setTeam('')
        handleClose()
        handleUpdateClose()
        setUpdateTeam({id: '', name: ''});
        SettingsService.getTeams().then(response => {
            console.log(response);
            if (response === undefined) {
                setTeams([])
                setLoading(false);
            }
            let teams = response.data.teams;
            setTeams(teams);
            setLoading(false);

            //   console.log();                                                                                        );
        }).catch(err => {
            console.log(err);
            setTeams([])
            setLoading(false);
        });
    }, [])

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content"
                className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <div className="container">

                                <div className="main-body">

                                    <nav aria-label="breadcrumb" className="main-breadcrumb">
                                        <ol className="breadcrumb">
                                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a>
                                            </Link>
                                            &nbsp;|&nbsp;
                                            <Link to="/settings"><a href><i
                                                className="fa fa-cog"/>&nbsp;Settings</a></Link>
                                            &nbsp;|&nbsp;
                                            <li className="breadcrumb-item">Teams</li>
                                        </ol>
                                    </nav>
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Getting Data,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {addLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Adding Team,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}

                                    {updateLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Updating Team,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {!loading && !addLoading && !updateLoading && (
                                        <div className="row gutters-sm">
                                            <div className="col-md-12 mt-2">
                                                <h4 className="font-weight-bold">Teams</h4>
                                                <div className={classes.root1}>
                                                    {/*   3 cards with tables*/}
                                                    <Card style={{maxWidth: "100%"}}>
                                                        <CardActions>
                                                            <button onClick={handleOpen}
                                                                    className="btn btn-sm btn-primary">
                                                                Add Team &nbsp; <i
                                                                className="fa-solid fa-people-group"></i>
                                                            </button>
                                                        </CardActions>
                                                        <CardActionArea>
                                                            <CardContent>
                                                                <TableContainer component={Paper}>
                                                                    <Table aria-label="simple table">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell>Name</TableCell>
                                                                                <TableCell align="right">Actions</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {teams.map((team, i) => {
                                                                                return (
                                                                                    <TableRow key={i}>
                                                                                        <TableCell component="th"
                                                                                                   scope="row">
                                                                                            {team.teamTitle}
                                                                                        </TableCell>
                                                                                        <TableCell align="right">
                                                                                            <button
                                                                                                onClick={() => handleUpdateOpen(team)}
                                                                                                className="btn btn-sm btn-warning">
                                                                                                Update&nbsp;<i
                                                                                                className="fa fa-edit"/>
                                                                                            </button>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                )

                                                                            })}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </CardContent>
                                                        </CardActionArea>
                                                    </Card>
                                                </div>
                                            </div>

                                            <Modal
                                                open={open}
                                                onClose={handleClose}
                                                aria-labelledby="simple-modal-title"
                                                aria-describedby="simple-modal-description"
                                            >
                                                <div style={modalStyle} className={classes.paper}>
                                                    <h2 id="simple-modal-title">Add Team</h2>
                                                    <form className={classes.root1} noValidate autoComplete="off">
                                                        <TextField id="standard-basic" label="Team Name" value={team}
                                                                   onChange={(e) => setTeam(e.target.value)}/>
                                                    </form>
                                                    <button onClick={handleAddTeam} className="btn btn-sm btn-primary">
                                                        Submit &nbsp; <i className="fa fa-send"/>
                                                    </button>
                                                    <button onClick={handleClose} className="btn btn-sm btn-warning">
                                                        Cancel &nbsp; <i className="fa fa-close"/>
                                                    </button>
                                                </div>
                                            </Modal>
                                            <Modal
                                                open={updateOpen}
                                                onClose={handleUpdateClose}
                                                aria-labelledby="simple-modal-title"
                                                aria-describedby="simple-modal-description"
                                            >
                                                <div style={modalStyle} className={classes.paper}>
                                                    <h2 id="simple-modal-title">Add Team</h2>
                                                    <form className={classes.root1} noValidate autoComplete="off">
                                                        <TextField id="standard-basic" disabled={true} label="Team Id"
                                                                   value={updateTeam.id}
                                                                   onChange={(e) => setTeam(e.target.value)}/>
                                                        <TextField id="standard-basic" label="Team Name"
                                                                   value={updateTeam.name}
                                                                   onChange={(e) => setUpdateTeam({
                                                                       id: updateTeam.id,
                                                                       name: e.target.value
                                                                   })}/>
                                                    </form>
                                                    <button onClick={handleUpdate} className="btn btn-sm btn-primary">
                                                        Update &nbsp; <i className="fa fa-send"/>
                                                    </button>
                                                    <button onClick={handleUpdateClose}
                                                            className="btn btn-sm btn-warning">
                                                        Cancel &nbsp; <i className="fa fa-close"/>
                                                    </button>
                                                </div>
                                            </Modal>
                                        </div>
                                    )}
                                </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Teams
